var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"18d677fa31c90cb38ccd7e8235a857b9cb2c70ba"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["virtual-travel-xpos@travpro-mobile"]={id:"18d677fa31c90cb38ccd7e8235a857b9cb2c70ba"};
      